import React, { useEffect, useState, useContext } from "react";
import { auth, firestore } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, onSnapshot } from "firebase/firestore";

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (authUser) => {
      if (authUser) {
        getDoc(doc(firestore, "users", authUser.uid))
          .then((snapshot) => {
            const dbUser = snapshot.data();
            // default empty roles
            if (dbUser) {
              if (!dbUser.roles) {
                dbUser.roles = [];
              }
              authUser = {
                uid: authUser.uid,
                email: authUser.email,
                emailVerified: authUser.emailVerified,
                providerData: authUser.providerData,
                ...dbUser,
              };
            }
            setCurrentUser(authUser);
          });
        setCurrentUser(authUser);
      } else {
        setCurrentUser(undefined);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={ {currentUser} } >
      {children}
    </AuthContext.Provider>
  );
};
// useAuth Hook!
export const useAuth = () => {
  const { currentUser } = useContext(AuthContext);
  return currentUser;
}

export function useUserExt(uid) {
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(true)
    const [userExt, setUserExt] = useState(null)
    
    useEffect(
        () => {
            if (!uid) {
              setLoading(false);
              return;
            }
            const userRef = doc(firestore, 'users', uid);
            const unsubscribe = onSnapshot(
              userRef,
              (docSnap) => {
                setUserExt({ ...docSnap.data(), uid: docSnap.id });
                setLoading(false);
              },
              (err) => {
                setError(err);
              }
            );
            return () => unsubscribe();
        },
        [uid]
    )

    return {
        error,
        loading,
        userExt,
    };
}

export function useAgentExt(uid) {
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(true)
    const [userAgent, setUserAgent] = useState(null)
    
    useEffect(
        () => {
            if (!uid) {
              setLoading(false);
              return;
            }
            const agentRef = doc(firestore, 'agent', uid);
            const unsubscribe = onSnapshot(
              agentRef,
              (docSnap) => {
                if (docSnap.exists()) {
                  setUserAgent({ ...docSnap.data(), uid: docSnap.id });
                  setLoading(false);
                } else {
                  setLoading(false);
                  setUserAgent(null);
                }
              },
              (err) => {
                setLoading(false);
                setError(err);
                setUserAgent(null);
              }
            );
            return () => unsubscribe();
        },
        [uid]
    )

    return {
        error,
        loading,
        userAgent,
    };
}

export function useAdminExt(uid) {
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(true)
    const [userAdmin, setUserAdmin] = useState(false)
    
    useEffect(
        () => {
            if (!uid) {
              setLoading(false);
              return;
            }
            const adminRef = doc(firestore, 'admin', uid);
            const unsubscribe = onSnapshot(
              adminRef,
              (docSnap) => {
                if (docSnap.exists()) {
                  setUserAdmin(true);
                  setLoading(false);
                } else {
                  setUserAdmin(false);
                  setLoading(false);
                }
              },
              (err) => {
                setUserAdmin(false);
                setError(err);
                setLoading(false);
              }
            );
            return () => unsubscribe();
        },
        [uid]
    )

    return {
        error,
        loading,
        userAdmin,
    };
}